<template>
    <div >
        <div class="joueur" v-if="tournoi.joueurs[numero]!=null && !forme"> 
        {{numero+1}} &nbsp; {{tournoi.joueurs[numero].pseudo}}
        </div>
        <div class="nomprenom"  v-if="tournoi.joueurs[numero]!=null">
        {{tournoi.joueurs[numero].nom}} &nbsp;{{tournoi.joueurs[numero].prenom}}
        </div>
    </div>
</template>
<style scoped>
    .joueur {
        font-size: 14px;
    }
    .nomprenom {
        font-size: 11px;
        font-style: italic;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
</style>
<script>
export default {
    props: ["numero", 'tournoi', 'forme']
}
</script>